import { STATS } from "@/mock";

export default function StatsSection() {
  return (
    <section className="bg-white py-16 -mt-1 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 text-center">
          {STATS.map((stat, idx) => (
            <div
              key={idx}
              className="group border-l-4 border-dorado pl-5 py-2 text-left transition-transform hover:-translate-y-1"
              data-testid={`stat-${idx}`}
            >
              <p className="font-heading font-bold text-3xl sm:text-4xl text-municipal">{stat.value}</p>
              <p className="text-gray-500 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
